import { Dispatch } from "react"
import { Dayjs } from "dayjs"
import qs from "qs"

import http from "../../../http_comon"
import {
    IAnnouncementItem,
    IAnnouncementResponse,
    AnnouncementUserActionTypes,
    AnnouncementUserAction,
    IAnnouncementPage,
} from "./types"
import { ServerError } from "../../../store/types"

require('dayjs/locale/uk')

export const GetNovelties = (isProject: boolean, searchBy: string, search: string, page: number, rowsPerPage: number, date: Dayjs | null) => {
    return async (dispatch: Dispatch<AnnouncementUserAction>) => {
        try {
            let response = await http.get<IAnnouncementResponse>(`api/Announcement/GetNovelties`, {
                params: {
                    isProject: isProject,
                    searchBy: searchBy,
                    search: search,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    date: date?.add(2, 'hour').toJSON()
                },
                paramsSerializer: params => {
                    return qs.stringify({ ...params })
                }
            });

            dispatch({
                type: AnnouncementUserActionTypes.GET_NOVELTIES,
                payload: response.data
            })

            return Promise.resolve();
        }
        catch (error) {
            return Promise.reject(error as ServerError)
        }
    }
}

export const AddNovelties = (isProject: boolean, searchBy: string, search: string, page: number, rowsPerPage: number, date: Dayjs | null) => {
    return async (dispatch: Dispatch<AnnouncementUserAction>) => {
        try {
            let response = await http.get<IAnnouncementResponse>(`api/Announcement/GetNovelties`, {
                params: {
                    isProject: isProject,
                    searchBy: searchBy,
                    search: search,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    date: date?.add(2, 'hour').toJSON()
                },
                paramsSerializer: params => {
                    return qs.stringify({ ...params })
                }
            });

            dispatch({
                type: AnnouncementUserActionTypes.ADD_NOVELTIES,
                payload: response.data
            })

            return Promise.resolve();
        }
        catch (error) {
            return Promise.reject(error as ServerError)
        }
    }
}

export const GetAnnouncementByUrlSlug = (urlSlug: string) => {
    return async (dispatch: Dispatch<AnnouncementUserAction>) => {
        try {
            let response = await http.get<IAnnouncementPage>(`api/Announcement/GetByUrlSlug`, {
                params: {
                    urlSlug: urlSlug,
                },
                paramsSerializer: params => {
                    return qs.stringify({ ...params })
                }
            });

            dispatch({
                type: AnnouncementUserActionTypes.GET_ANNOUNCEMENT_BY_URLSLUG,
                payload: response.data
            })

            return Promise.resolve();
        }
        catch (error) {
            return Promise.reject(error as ServerError)
        }
    }
}

export const GetSimilar = (isProject: boolean, urlSlug: string) => {
    return async (dispatch: Dispatch<AnnouncementUserAction>) => {
        try {
            let response = await http.get<Array<IAnnouncementItem>>(`api/Announcement/GetSimilar`, {
                params: {
                    isProject: isProject,
                    urlSlug: urlSlug,
                },
                paramsSerializer: params => {
                    return qs.stringify({ ...params })
                }
            });

            dispatch({
                type: AnnouncementUserActionTypes.GET_SIMILAR,
                payload: response.data
            })

            return Promise.resolve();
        }
        catch (error) {
            return Promise.reject(error as ServerError)
        }
    }
}


export const GetHeaderProjects = (isProject: boolean, searchBy: string, search: string, page: number, rowsPerPage: number, date: Dayjs | null) => {
    return async (dispatch: Dispatch<AnnouncementUserAction>) => {
        try {
            let response = await http.get<IAnnouncementResponse>(`api/Announcement/GetNovelties`, {
                params: {
                    isProject: isProject,
                    searchBy: searchBy,
                    search: search,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    date: date?.add(2, 'hour').toJSON()
                },
                paramsSerializer: params => {
                    return qs.stringify({ ...params })
                }
            });

            dispatch({
                type: AnnouncementUserActionTypes.GET_HEADER_PROJECTS,
                payload: response.data
            })

            return Promise.resolve();
        }
        catch (error) {
            return Promise.reject(error as ServerError)
        }
    }
}
